<script>
import ModifierMotDePasse from "@/components/organisms/mon-compte/mon-profil/modifier-mot-de-passe";

import clientApiDrive from "@/services/http/api-drive/client";

export default {
  components: {
    ModifierMotDePasse
  },
  props: {
    isObsolete: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ["updated"],
  data() {
    return {
      error: null,
      isLoading: false
    };
  },
  methods: {
    async save(data) {
      this.isLoading = true;
      try {
        await this.$apiDrive
          .use(clientApiDrive)
          .changePassword(data.old_password, data.password);
        this.$emit("updated");
      } catch (error) {
        this.error = this.$apiDrive.getErrorData(error);
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<template>
  <ModifierMotDePasse
    :error="error"
    :is-loading="isLoading"
    :is-obsolete="isObsolete"
    @save="save"
  />
</template>
